module.exports = __webpack_public_path__ + "media/images/icon-encounters-5dd008479eb2430983cc71ee662887f5.svg";